import { createSvg } from '../createSvg';

const ImportSquare = ({ strokeWidth = 1.5 }): JSX.Element => {
    return (
        <g id={'contour'}>
            <path
                d='M16.44 8.89999C20.04 9.20999 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998
                    21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.23999 7.46998 8.90999'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M12 2V14.88'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M15.3499 12.65L11.9999 16L8.6499 12.65'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
    );
};

export default createSvg(
    ImportSquare,
    'import-square',
);
